import React, { useContext } from 'react';
import styled from 'styled-components';

import { Title } from 'components';
import { AuthContext } from 'contexts';
import { hasValidStripeMlsProductId } from 'utils';
import { useBreakpoint } from 'hooks';
import { AnsweringServiceType } from '@bb/domain/dist/types/AnsweringSubscription';
import { StyledPageContent } from '../StyledComponents';

import PaymentMethod from './PaymentMethod';
import StartDate from './StartDate';
import YourPlanInfo from './YourPlanInfo';
import YourTotal from './YourTotal';
import ActionButton from './ActionButton';
import AppointmentDeskContext from '../AppointmentDeskContext';

const Activate: React.FC = () => {
  const { sm } = useBreakpoint();
  const { answeringPortalConfig } = useContext(AuthContext);
  const {
    association,
    portalConfig,
    isBoardCovered,
    selectedSubscriptionType,
  } = useContext(AppointmentDeskContext);

  const isMlsCovered =
    portalConfig?.appointmentDeskMlsPay &&
    !hasValidStripeMlsProductId(answeringPortalConfig?.mlsProductId);

  const isAssociationCovered =
    hasValidStripeMlsProductId(answeringPortalConfig?.mlsProductId) &&
    ((selectedSubscriptionType === AnsweringServiceType.AppointmentDesk &&
      association?.useAppointmentDesk) ||
      (selectedSubscriptionType === AnsweringServiceType.LiveConciergePlus &&
        association?.useLiveConciergePlus));

  return (
    <StyledPageContent>
      <Title level={2} data-cy="activate-plan-title">
        Activate your plan
      </Title>
      <StyledActivationContainer $sm={sm}>
        <YourPlanInfo isMlsCovered={isMlsCovered} />
        <StartDate isMlsCovered={isMlsCovered} />
        {!isMlsCovered && !isBoardCovered && !isAssociationCovered && (
          <>
            <PaymentMethod />
            <YourTotal />
          </>
        )}
        <ActionButton />
      </StyledActivationContainer>
    </StyledPageContent>
  );
};

const StyledActivationContainer = styled.div<{ $sm: boolean }>`
  width: ${({ $sm }) => ($sm ? 'max(480px, 40%)' : '100%')};
  display: flex;
  flex-flow: column nowrap;
  margin-top: 24px;
`;

export default Activate;
